import { fromJS } from 'immutable';
import { ENTITY_LOADED } from '@uncinc/react-drupal-core';
import { POPUPS_LOADED } from '../../actions/PopupAnnouncement';

const initialState = fromJS({
  pagesVisitedThisSession: 0,
  popups: [],
});

/**
 * @example
 * @param state
 * @param action
 */
export default function popupAnnouncement(state = initialState, action = {}) {
  switch (action.type) {
    case ENTITY_LOADED: {
      return state.set('pagesVisitedThisSession', state.get('pagesVisitedThisSession') + 1);
    }

    case POPUPS_LOADED: {
      return state.set('popups', action.payload);
    }

    default:
      return state;
  }
}
